export default {
  selectTicketType: '选择门票类型',
  confirmTicketDetails: '确认门票信息',
  payment: '支付门票订单',
  receiveETicket: '收取电子门票',
  exhibitionTickets: '展会门票',
  viewExhibitions: '查看展会',
  exhibitionDates: '展会时间',
  viewMap: '查看地图',
  organizer: '主办单位',
  venue: '举办展馆',
  hallNumber: '展馆号',
  venueAddress: '举办地址',
  ticketType: '门票类型',
  eTicket: '电子票',
  fullEventPass: '展期票',
  singleDayTicket: '单日票',
  freeAdmission: '免费',
  limitedTimeOffer: '限时',
  soldOut: '暂缺',
  discounted: '折',
  RMB: '元',
  deliveryMethod: '配送方式',
  'selectCompany/individual': '选择公司/个人',
  company: '公司',
  individual: '个人',
  visitor: '观展人',
  addVisitor: '新增观展人',
  ticketPreview: '门票示意图',
  businessLicense: '营业执照',
  businessLicenseSample: '营业执照示例',
  completeProfile: '去完善资料',
  fullName: '姓名',
  gender: '性别',
  male: '男',
  female: '女',
  jobTitle: '职位',
  mobileNumber: '手机号',
  email: '邮箱',
  idType: '证件类型',
  idNumber: '证件号',
  actions: '操作',
  edit: '编辑',
  delete: '删除',
  agreeSubmit: '同意以上协议并提交订单',
  basicInfo: '展会基本信息',
  chineseName: '中文名',
  location: '举办地点',
  abbreviation: '简称',
  visitorCount: '观众数量',
  exhibitorCount: '展商数量',
  exhibitionIntro: '展会简介',
  onSitePhotos: '现场图片',
  moreTickets: '更多展会门票',
  clickToBuy: '点击购买',
  orderAmount: '订单金额',
  modifyOrder: '返回修改订单',
  alipay: '支付宝',
  wechatPay: '微信支付',
  redirectToAlipay: '点击“去支付”，跳转到支付宝付款',
  scanWechatQR: '点击“去支付”，打开手机微信“扫一扫”，扫描二维码支付',
  proceedToPay: '去支付',
  paymentSecurity: '聚展支付安全承诺',
  preRegistrationTickets: '预登记门票',
  deliveryTickets: '快递票',
  eInvoice: '电子发票',
  notes: '注意事项',
  serviceFee: '服务费',
  vat: '增值税',
  promotion: '促销优惠',
  totalAmount: '总额',
  limitedTimeFree: '限时免费',
  feeInclusion: '（含：增值税，服务费）',
  imageRequirements: '仅支持尺寸大于600*800，文件大小小于2M的图片',
  ticketingTerms: '购票须知',
  ticketGuidelines:
    '购票成功后，打开网站/小程序出示门票二维码，请携带购票时填写的证件原件验证入场，最终地址以展会现场实际为准。',
  entryInstructions:
    '门票预订成功后，请携带观展人本人身份证原件刷卡入场或至现场服务台换领纸质进馆证！',
  entryProcedure:
    '门票预订成功后，请携带观展人本人护照原件及电子门票至现场服务台或自助机换领进馆证入场！',
  eventUpdatesNotice:
    '展会时间变更或取消，将统一发送短信及邮件提醒观展人，更新的时间也将通过短信及邮件及时通知，请注意查阅！也可通过关注聚展小程序或公众号接收提醒！',
  feeCoverage:
    '费用含门票费、代订服务费，具体明细见价格明细展示，提供门票出票、展会时间变更或取消通知，展会举办地址变更、会议提醒等服务。',
  ticketUsagePolicy: '门票为申请人本人使用，不能转借他人。电子门票可在展馆服务台换领纸质进馆证。',
  ticketPurchaseNotice:
    '请观众在购票时留意所购电子门票的参观日期和进场时间，售出后不可退票、换票，不可转赠，请妥善保存。',
  audienceScope:
    '该展为B2B展，针对专业人士开放，提交申请后需要通过审核，审核过程中我司有权要求申请者补充相关辅助性材料。',
  refundPolicy: '如提交信息不符合审核要求或审核时间截止不能出票的，将在3个工作日原路退回费用。',
  privacyConsent1: '我同意根据本',
  privacyConsent2: '《隐私条例》',
  privacyConsent3: '保留我的个人数据',
  wechatScanPayment: '打开手机微信“扫一扫”，扫描二维码支付',
  visitorRealNameSystem: '参观人员需展会实名制',
  bookingPurpose: '为减少展会现场排队及人员集聚接触，预约成功后会以短信、微信或邮件的形式推送',
  ticketStatus: '无票状态',
  bookingStatus: '暂未开放在线预约门票服务',
  bookingClosed: '已截止在线预约门票服务',
  refundPolicy2: '不支持退',
  ticketNature:
    '票品为有价证券，非普通商品，其背后承载的文化服务具有时效性，稀缺性等特征，不支持退换',
  realNamePolicy: '实名制观展',
  ticketingRule: '本项目需实名制购票及入场，观展请本人携带购票时填写证件验证入场',
  electronicTickets:
    '电子票：通过票夹中的二维码或身份证，可以直接验票入场（具体以下单后票夹信息为准）',
  courierTickets:
    '快递票：纸质票会在开票后快递到您留下的收货地址，需您承担邮寄费用。注:离开展时间仅3天时，不再客送快递票，支持在指定取票地点取票(具体以下单后票夹信息为准)',
  invoiceTiming:
    '该项目支持开具电子发票，请您在展出开始前通过订单页补开，发票将在展出结束后1个月左右，统一由主办方提供',
  companyName: '公司名称',
  attendeeName: '姓名',
  companyNameInput: '请输入公司名称',
  nameInput: '请输入姓名',
  confirmButton: '确 定',
  cancelButton: '取 消',
  addAttendee: '新增观展人信息',
  genderSelection: '请选择性别',
  positionSelection: '请选择职位',
  generalStaff: '普通员工',
  manager: '经理',
  generalManager: '总经理',
  chairman: '董事长',
  phoneNumberLabel: '参展人手机号（用于接收短信通知）',
  emailLabel: '参展人邮箱（用于接收通知）',
  idTypeLabel: '请选择证件类型',
  idCard: '身份证',
  passport: '护照',
  hkMacaoPass: '港澳居民来往内地通行证',
  taiwanPass: '台湾居民来往内地通行证',
  idNumberInput: '请输入证件号',
  departmentLabel: '部门',
  marketingDept: '市场部',
  operationsDept: '运营部',
  adminDept: '管理部',
  procurementDept: '采购部',
  companyTypeLabel: '贵公司所属类型(最多选三个)',
  otherOption: '其他',
  industryServedLabel: '贵公司服务于哪个行业(最多选三个)',
  productInterestLabel: '阁下感兴趣的产品是: (多选)',
  imageSizeLimit: '仅支持文件大小小于2M的图片',
  idFrontExample: '身份证正面示例',
  passportFrontExample: '护照正面示例',
  hkMacaoFrontExample: '港澳居民来往内地通行证正面示例',
  taiwanFrontExample: '台湾居民来往内地通行证正面示例',
  idBackExample: '身份证反面示例',
  passportBackExample: '护照反面示例',
  hkMacaoBackExample: '港澳居民来往内地通行证反面示例',
  taiwanBackExample: '台湾居民来往内地通行证反面示例',
  iDPhotos: '证件照',
  portraitRequirement: '仅支持尺寸大于600*800，文件大小小于2M的图片',
  avatarExample: '头像示例',
  businessCardLabel: '名片',
  businessCardExample: '名片示例'
}
